import { render, staticRenderFns } from "./EnterMarksHeader.vue?vue&type=template&id=15696b0c&scoped=true"
import script from "./EnterMarksHeader.vue?vue&type=script&lang=js"
export * from "./EnterMarksHeader.vue?vue&type=script&lang=js"
import style0 from "./EnterMarksHeader.vue?vue&type=style&index=0&id=15696b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15696b0c",
  null
  
)

export default component.exports